export const VALID_LOCALES = Object.assign({
    en: "English"
}, __LOCALES__); // eslint-disable-line no-undef
const LOCALE_KEYS = [
    "language",
    "browserLanguage",
    "systemLanguage",
    "userLanguage"
];
const R_LOCALE = /^([a-z]{2})(-[A-Z]{2})?$/;
export function getBrowserLocales() {
    if (Array.isArray(navigator.languages)) {
        return navigator.languages;
    }
    for (const key of LOCALE_KEYS) {
        const locale = navigator[key];
        if (locale != null && locale.length > 0) {
            const locales = [locale];
            const match = locale.match(R_LOCALE);
            if (match != null) {
                locales.push(match[1]);
            }
            return locales;
        }
    }
    return [];
}



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/i18n/utils.ts